module.exports = __webpack_public_path__ + "static/img/a81f2971daf4b36bf4f618431b64b436.fdaddc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a81f2971daf4b36bf4f618431b64b436.jpg
// module id = /1yu
// module chunks = 1